import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { INCREASE_ACCOUNT_NUMBER_BASE_PATH } from '../../../../../../../../../features/vendor/increase/account-number/increase-account-number-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'increase-account-number-list',
        label: 'Increase',
        to: INCREASE_ACCOUNT_NUMBER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
